function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// Turn indicator messages
const DRAW_PHASE = [
  "You're up! Grab a card.",
  "Your shot — stock or discard?",
  "Step up to the tee.",
  "Your move, champ.",
  "Time to play. Choose wisely.",
  "You're on the clock.",
  "Your honor. Pick a pile.",
];

const DECISION_PHASE = [
  "Swap it in or toss it back?",
  "Keep it or chuck it?",
  "That card's fate is in your hands.",
  "Swap or discard — no pressure.",
  "In the hand or in the trash?",
  "Make the call.",
];

const OPPONENT_TURN = [
  "{name} is thinking...",
  "{name} is eyeing the pile...",
  "{name}'s turn — watch closely.",
  "Waiting on {name}...",
  "{name} is plotting something...",
  "{name} is sizing up the options...",
  "{name}'s got the honor...",
];

function getDrawPhaseMessage() {
  return pick(DRAW_PHASE);
}

function getDecisionPhaseMessage() {
  return pick(DECISION_PHASE);
}

function getOpponentTurnMessage(name) {
  return pick(OPPONENT_TURN).replace('{name}', name);
}

// Card reveal messages
const REVEAL_MESSAGES = [
  "Peek at 2 of your cards — choose wisely!",
  "Flip 2 cards. What's hiding under there?",
  "Time to sneak a peek — pick 2.",
  "Reveal 2 cards. Knowledge is power.",
  "Pick 2 to flip. No takebacks!",
];

function getRevealMessage(remaining) {
  if (remaining === 1) return "One more — pick your last peek.";
  return pick(REVEAL_MESSAGES);
}

// Round end messages
function getRoundEndTitle(roundNum, myScore, bestScore, isBest) {
  if (isBest && myScore < 0) return `Round ${roundNum} — Under par! Nice.`;
  if (isBest && myScore === 0) return `Round ${roundNum} — Even par. Solid.`;
  if (isBest) return `Round ${roundNum} — You crushed it!`;
  if (myScore < 0) return `Round ${roundNum} — Under par!`;
  if (myScore === 0) return `Round ${roundNum} — Even par.`;
  if (myScore > 15) return `Round ${roundNum} — Rough hole...`;
  if (myScore > 10) return `Round ${roundNum} — Could've been worse.`;
  return `Round ${roundNum} in the books!`;
}

function getScoreReaction(score) {
  if (score < -2) return '🔥 Way under!';
  if (score < 0) return '🔥 Under par!';
  if (score === 0) return '😎 Even par';
  if (score <= 5) return '👍 Not bad';
  if (score <= 10) return '😬 Could be worse';
  if (score <= 15) return '😅 Rough round';
  return '💀 Ouch';
}

// Game over messages
function getWinnerMessage(name, margin) {
  if (margin > 20) return `🏆 ${name} absolutely dominated!`;
  if (margin > 10) return `🏆 ${name} ran away with it!`;
  if (margin <= 3) return `🏆 ${name} wins by a hair!`;
  if (margin <= 5) return `🏆 ${name} edges out the win!`;
  return `🏆 ${name} takes the trophy!`;
}

function getLoserMessage(rank, totalPlayers) {
  if (rank === 2) return 'So close! Silver medal energy.';
  if (rank === totalPlayers) return pick([
    "Hey, someone's gotta keep the bench warm.",
    "The 19th hole awaits. Drinks on you.",
    "There's always next round.",
  ]);
  return pick([
    'Better luck on the back nine.',
    'Not your day on the course.',
    'The greens were tough today.',
  ]);
}

// Opponent draw flavor
function getOpponentDrawMessage(name, card) {
  const rank = card?.rank || '?';
  return pick([
    `${name} snagged the ${rank}!`,
    `${name} grabbed the ${rank} — bold move.`,
    `${name} picked up the ${rank}.`,
    `${name} drew the ${rank} from the pile.`,
  ]);
}

// Loading/wait states
function getLoadingMessage(type) {
  switch (type) {
    case 'create': return pick(['Setting up the course...', 'Reserving a tee time...', 'Shuffling the deck...']);
    case 'join': return pick(['Walking up to the tee...', 'Joining the round...', 'Grabbing your clubs...']);
    case 'start': return pick(['Teeing off...', 'Here we go...', 'First drive incoming...']);
    case 'wait': return pick(["The host is lining up their shot...", "Hang tight — game's about to start...", "Almost there..."]);
    default: return 'Shuffling the deck...';
  }
}

// Error messages
function getFriendlyError(errorMessage) {
  if (!errorMessage) return "Whoops! Something went sideways. Try again.";
  const lower = errorMessage.toLowerCase();
  if (lower.includes('internal')) return "Whoops! Something went sideways. Try again.";
  if (lower.includes('not your turn') || lower.includes('permission')) return "Hold your horses — it's not your turn!";
  if (lower.includes('not found')) return "Can't find that room. Double-check the code?";
  if (lower.includes('full')) return "That room's packed! No more spots.";
  if (lower.includes('already')) return "You're already in there!";
  return errorMessage;
}

export {
  getDrawPhaseMessage,
  getDecisionPhaseMessage,
  getOpponentTurnMessage,
  getRevealMessage,
  getRoundEndTitle,
  getScoreReaction,
  getWinnerMessage,
  getLoserMessage,
  getOpponentDrawMessage,
  getLoadingMessage,
  getFriendlyError,
};
